import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6a334af0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main" }
const _hoisted_2 = {
  key: 0,
  class: "inner"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, [
  /*#__PURE__*/_createTextVNode(" Souhlasím se "),
  /*#__PURE__*/_createElementVNode("a", {
    href: "/gdpr.pdf",
    target: "_blank"
  }, "zpracováním osobních údajů"),
  /*#__PURE__*/_createTextVNode(" a s tím, že mi EY občas pošle e‑mailem pracovní nabídku snů. ")
], -1))

import { useField } from "vee-validate";


export default /*#__PURE__*/_defineComponent({
  __name: 'ConsentCheckbox',
  setup(__props) {

const { checked, handleChange } = useField("consent", undefined, {
  type: "checkbox",
  checkedValue: true,
  uncheckedValue: false,
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "outer",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(handleChange)(!_unref(checked)))),
      tabindex: "3"
    }, [
      (_unref(checked))
        ? (_openBlock(), _createElementBlock("div", _hoisted_2))
        : _createCommentVNode("", true)
    ]),
    _hoisted_3
  ]))
}
}

})